import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import ToolRow from "./ToolRow";
import type { MCPConnectionTool } from "../../../services/agent-tools-service";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  tools: MCPConnectionTool[];
  onToolChangeAccess: (tool: MCPConnectionTool) => void;
  canManage: boolean;
  defaultOpen?: boolean;
};

const ToolGroup = ({
  title,
  tools,
  onToolChangeAccess,
  canManage,
  defaultOpen = false,
}: Props) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(defaultOpen);
  const ChevronIcon = open ? ChevronDown : ChevronRight;

  return (
    <div className="border-b border-border">
      <div className="flex h-[67px] items-center">
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className="flex h-full w-full items-center gap-2 rounded-sm text-start text-sm font-medium text-foreground outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          aria-expanded={open}
        >
          <ChevronIcon
            className={`size-4 text-muted-foreground ${i18n.dir() === "rtl" && !open ? "rotate-180" : ""}`}
          />
          <span>{title}</span>
          <span className="flex h-4 min-w-4 items-center justify-center rounded-full bg-accent px-1 text-xs text-accent-foreground">
            {tools.length}
          </span>
        </button>
      </div>

      {open && tools.length > 0 && (
        <div>
          {tools.map((tool) => (
            <ToolRow
              key={tool.id}
              tool={tool}
              onChangeAccess={onToolChangeAccess}
              canManage={canManage}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ToolGroup;
